import {
  getTextDirection,
  shouldUseGlobalTextAlign,
} from '@/lib/utils/localization/isRtlLanguage'
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect } from 'react'

export const useRtlDirection = () => {
  const {
    app: { language, marketExceptions },
  } = useGlobalStore()

  const textDirection = getTextDirection(
    language,
    marketExceptions || undefined,
  )

  const isRtl = textDirection === 'rtl'

  const enableGlobalTextAlign = shouldUseGlobalTextAlign(
    language,
    marketExceptions || undefined,
  )

  useEffect(() => {
    const htmlElement = document.documentElement
    htmlElement.setAttribute('dir', textDirection)
    htmlElement.setAttribute('lang', language)

    htmlElement.classList.remove(
      'rtl-global-text-align',
      'rtl-flex-reverse-enabled',
    )

    if (isRtl && enableGlobalTextAlign) {
      htmlElement.classList.add('rtl-global-text-align')
    }
  }, [textDirection, language, isRtl, enableGlobalTextAlign, marketExceptions])

  return {
    textDirection,
    isRtl,
    language,
    marketExceptions,
    enableGlobalTextAlign,
  }
}
